import React from "react";
import { Row, Col, Typography, Space, Grid } from "antd";
import Security from "../../assets/images/Security.svg";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function SecuritySection() {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        background: "#ffffff",
        padding: screens.md ? "80px 24px" : "40px 16px",
      }}
    >
      {/* MAIN CONTAINER */}
      <div
        style={{
          maxWidth: 1128,
          height: screens.md ? 400 : "auto",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Row align="middle" gutter={[48, 48]} style={{ width: "100%" }}>
          {/* LEFT CONTENT */}
          <Col xs={24} md={12}>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Title level={2} style={{ color: "#2d1e6b", marginBottom: 8 }}>
                Security is our top priority
              </Title>

              <Text style={{ color: "#555", fontSize: 15 }}>
                • <strong>Free SSL certificates</strong> installed automatically
                to secure your clients’ sensitive information.
              </Text>

              <Text style={{ color: "#555", fontSize: 15 }}>
                • <strong>Malware scanner</strong> to proactively detect and
                remove harmful files.
              </Text>

              <Text style={{ color: "#555", fontSize: 15 }}>
                • <strong>Privacy protection</strong> to keep your personal
                information safe.
              </Text>

              <Text style={{ color: "#555", fontSize: 15 }}>
                • Defend against unwanted access by employing{" "}
                <strong>IP and country blocking</strong>, included with
                Hostinger CDN.
              </Text>
            </Space>
          </Col>

          {/* RIGHT IMAGE */}
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={Security}
              alt="Website Security"
              style={{
                width: "100%",
                maxWidth: 552,
                height: "auto",
                display: "block",
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
